/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ProvisionDeviceLookupValues
 */
export interface ProvisionDeviceLookupValues {
    /**
     * List of DeviceTypes to use in the drop-down
     * @type {Array<string>}
     * @memberof ProvisionDeviceLookupValues
     */
    deviceTypes?: Array<ProvisionDeviceLookupValuesDeviceTypesEnum>;
    /**
     * Mapping of DeviceType to a list of Model values to use in the Model drop-down
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ProvisionDeviceLookupValues
     */
    deviceTypeModelValues?: { [key: string]: Array<string> };
}

/**
 * @export
 */
export const ProvisionDeviceLookupValuesDeviceTypesEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type ProvisionDeviceLookupValuesDeviceTypesEnum =
    (typeof ProvisionDeviceLookupValuesDeviceTypesEnum)[keyof typeof ProvisionDeviceLookupValuesDeviceTypesEnum];

/**
 * Check if a given object implements the ProvisionDeviceLookupValues interface.
 */
export function instanceOfProvisionDeviceLookupValues(
    value: object,
): value is ProvisionDeviceLookupValues {
    return true;
}

export function ProvisionDeviceLookupValuesFromJSON(
    json: any,
): ProvisionDeviceLookupValues {
    return ProvisionDeviceLookupValuesFromJSONTyped(json, false);
}

export function ProvisionDeviceLookupValuesFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ProvisionDeviceLookupValues {
    if (json == null) {
        return json;
    }
    return {
        deviceTypes:
            json["deviceTypes"] == null ? undefined : json["deviceTypes"],
        deviceTypeModelValues:
            json["deviceTypeModelValues"] == null
                ? undefined
                : json["deviceTypeModelValues"],
    };
}

export function ProvisionDeviceLookupValuesToJSON(
    value?: ProvisionDeviceLookupValues | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceTypes: value["deviceTypes"],
        deviceTypeModelValues: value["deviceTypeModelValues"],
    };
}
